/*
 * @Author: Json Chen
 * @Date: 2021-06-28 11:25:46
 * @LastEditTime: 2021-06-28 12:06:58
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/ShowExistValue.tsx
 */
import React from 'react';
import styles from '../style.module.less';
const ShowExistValue = ({ value }: any) => {
  return <div className={styles.existValue}>{value}</div>;
};

export default ShowExistValue;
